export default __webpack_public_path__ + "static/card-image-5-4467a77a4eab95bb717e82c8bda3ebed.jpg";